<div class="profile-container">
  <!-- Page Header -->
    <header class="page-header">
      <div class="page-header-title">
        <h1>Mein Profil</h1>
        <p class="subtitle">Verwalte dein Profil und Einstellungen</p>
      </div>
      <div class="page-header-actions">
        <button
          class="btn btn-tertiary"
          (click)="onRefreshToken()"
          [disabled]="isRefreshing()"
        >
          @if (isRefreshing()) {
            <svg class="spinner" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" opacity="0.25"></circle>
              <path d="M4 12a8 8 0 018-8" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round"></path>
            </svg>
          } @else {
            <app-icon [type]="IconType.REFRESH" [size]="16"></app-icon>
          }
          Token aktualisieren
        </button>
      </div>
    </header>

    @if (currentUser(); as user) {
      <!-- Profile Header Section -->
      <section class="profile-section">
        <app-profile-header
          [user]="user"
          [isOAuthUser]="isOAuthUser()"
        ></app-profile-header>
      </section>

      <!-- Personal Data: General / Address / Contact -->
      <section class="profile-section profile-data-section">
        <h2 class="section-title">
          <app-icon [type]="IconType.USER" [size]="20"></app-icon>
          Persönliche Daten
        </h2>

        <app-general-info
          #generalSection
          [user]="user"
          (save)="onSavePartial(generalSection, $event)"
        ></app-general-info>

        <app-address-info
          #addressSection
          [user]="user"
          (save)="onSavePartial(addressSection, $event)"
        ></app-address-info>

        <app-contact-info
          #contactSection
          [user]="user"
          (save)="onSavePartial(contactSection, $event)"
        ></app-contact-info>

        <app-sepa-account-info></app-sepa-account-info>
      </section>

      <!-- Clubs & Memberships Section -->
      @if (organizations().length > 0) {
        <section class="profile-section">
          <app-clubs-list
            [organizations]="organizations()"
            [memberships]="memberships()"
            [loading]="isLoadingDashboard()"
          ></app-clubs-list>
        </section>
      }

      <!-- Activity Overview Section -->
      <section class="profile-section">
        <h2 class="section-title">
          <app-icon [type]="IconType.ACTIVITY" [size]="20"></app-icon>
          Aktivitäten
        </h2>

        <!-- Upcoming Activities -->
        <div class="bookings-section">
          <app-upcoming-bookings
            [activities]="upcomingActivities()"
            [loading]="isLoadingDashboard()"
            (viewAll)="navigateToBookings()"
            (bookNow)="navigateToNewBooking()"
          ></app-upcoming-bookings>
        </div>

        <!-- Activity Cards Grid -->
        <div class="activity-grid">
          <app-activity-card
            title="Kurse"
            [count]="courseSessionsCount()"
            subtitle="kommende Termine"
            [icon]="IconType.USERS"
            accentColor="purple"
            actionLabel="Kurse anzeigen"
            [loading]="isLoadingDashboard()"
            emptyMessage="Keine Kurstermine"
            (action)="navigateToCourses()"
          ></app-activity-card>

          <app-activity-card
            title="Abonnements"
            [count]="subscriptionsCount()"
            subtitle="aktive Abos"
            [icon]="IconType.REPEAT"
            accentColor="green"
            actionLabel="Abos verwalten"
            [loading]="isLoadingDashboard()"
            emptyMessage="Keine aktiven Abos"
            (action)="navigateToSubscriptions()"
          ></app-activity-card>

          @if (waitlistCount() > 0) {
            <app-activity-card
              title="Warteliste"
              [count]="waitlistCount()"
              subtitle="Einträge"
              [icon]="IconType.CLOCK"
              accentColor="orange"
              actionLabel="Anzeigen"
              [loading]="isLoadingDashboard()"
              (action)="navigateToCourses()"
            ></app-activity-card>
          }
        </div>
      </section>

      <!-- Account Settings Section -->
      @if (!isOAuthUser()) {
        <section class="profile-section profile-account-section">
          <h2 class="section-title">
            <app-icon [type]="IconType.SETTINGS" [size]="20"></app-icon>
            Kontoeinstellungen
          </h2>
          <app-change-email
            [currentEmail]="user.email"
            (changeEmail)="onChangeEmail($event)"
          ></app-change-email>
          <app-change-password
            (changePassword)="onChangePassword($event)"
          ></app-change-password>
        </section>
      }

      <!-- Join Organization Section -->
      <section class="profile-section join-org-section">
        <app-join-organization></app-join-organization>
      </section>

      <!-- Back Link -->
      <div class="back-link">
        <a routerLink="/" class="link-text">
          <app-icon [type]="IconType.ARROW_LEFT" [size]="16"></app-icon>
          Zurück zur Startseite
        </a>
      </div>
    } @else {
      <!-- Loading State -->
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Profil wird geladen...</p>
      </div>
    }
</div>
